import { ViewContainerRef } from '@angular/core';
import { Directive } from '@angular/core';

@Directive({
  selector: '[appStepAnchor]'
})
export class StepAnchorDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
